import { useState, useCallback } from "react";
import _ from "lodash";

export default function useAudioUpload({ http, userId, setItems, itemIndex }) {
  const [previews, setPreviews] = useState([]);
  const [progress, setProgress] = useState({});

  const uploadAudio = useCallback(
    async (file, index) => {
      if (!file) return;

      const randomId = Math.random().toString(36).substring(2, 7);
      const extension = file.name.split(".").pop();
      const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");

      const size =
        file.size >= 1000000
          ? Math.ceil(file.size / 1048576) + "MB"
          : Math.ceil(file.size / 1024) + "KB";

      // 1️⃣ Ask backend for presigned URL
      const {
        data: { url, key },
      } = await http.post("public/milestones/presign", {
        file_name: nameWithoutExt,
        extension,
        mime: file.type,
        user_id: userId,
      });

      // 2️⃣ Add preview immediately
      setPreviews(prev => [
        ...prev,
        {
          index:itemIndex,
          progressId: randomId,
          name: nameWithoutExt,
          size,
          progress: 0,
        },
      ]);

      setProgress(prev => ({ ...prev, [randomId]: 0 }));

      // 3️⃣ Upload to S3
      await http.put(url, file, {
        headers: {
          "Content-Type": file.type,
          "x-amz-acl": "public-read",
        },
        onUploadProgress: e => {
          if (!e.total) return;
          const pct = Math.round((e.loaded / e.total) * 100);
          setProgress(prev => ({ ...prev, [randomId]: pct }));
        },
      });

      // 4️⃣ Confirm with backend
      const { data } = await http.post("public/milestones/confirm", {
        file_name: nameWithoutExt,
        extension,
        key,
        user_id: userId,
        size: file.size,
        mime: file.type,
      });

      // 5️⃣ Update parent items
      setItems(prev => {
        const buffer = _.cloneDeep(prev);
        buffer[itemIndex].value = data;
        return buffer;
      });

      // 6️⃣ Remove progress after completion
      setPreviews(prev =>
        prev.filter(item => item.progressId !== randomId
            // ? (() => {
            //     const { progress,progressId, ...rest } = item;
            //     return rest;
            //   })()
            // : item
        )
      );
    },
    [http, userId, setItems, itemIndex]
  );

  return {
    uploadAudio,
    previews,
    progress,
  };
}

